<header class="mb-10 flex items-center justify-between px-8 pt-10">
    <div class="flex items-center">
        <mat-icon class="mr-5 scale-150">{{ icon() }}</mat-icon>
        <h1 class="text-3xl font-medium">{{ title() }}</h1>
    </div>
    <div class="flex items-center gap-x-6">
        <mat-slide-toggle
            class="float-right"
            color="primary"
            (change)="onOffersTypeToggled($event)">
            Show archived
        </mat-slide-toggle>
        <button
            mat-flat-button
            color="primary"
            (click)="openCreateOfferDialog()">
            Create offer
        </button>
    </div>
</header>
<app-offers-table
    [offers]="offers()"
    [offersStore]="offersStore()">
</app-offers-table>
